/**
 * @class
 * @extends mkE.Base
 */
T.ListEvent = Class(
	/**
	 * @lends {T.ListEvent#}
	 */
	{
		LEGACY: [
			'kurzeme-2019',
			'vidzeme-2019',
			'zemgale-2020',
			'roadgames-urban-centrs',
			'roadgames-urban-agenskalns'
		],
		/** @type {DR.events.struct.Event} */
		event: null,
		/** @type {boolean} */
		isClickable: true,

		/**
		 * @param {DR.events.struct.Event} event
		 * @param {boolean} isStatic
		 * @private
		 */
		__construct: function ( event, isStatic = false ) {
			this.event = event;
			this.isStatic = isStatic;
			if( this.event ) {
				this._draw();
			} else {
				this._drawPlaceholder();
			}
		},
		_drawPlaceholder() {
			this.node = mkE({
				tag: 'div',
				className: 'event event-placeholder',
				els: [
					{
						tag: 'div',
						className: 'cover'
					},
					{
						tag: 'div',
						className: 'header',
						els: [
							{
								tag: 'span',
								className: 'title'
							}
						]
					}
				]
			});
		},
		_draw() {
			const event = this.event;
			const webImage = in_array(event.seoTitle, this.LEGACY);
			let classNames = ['event', 'event-' + event.seoTitle];
			if( event.hasEnded && !this.isStatic ) {
				classNames.push('past');
			}
			const isFuture = event.startTime > D.TIME;
			if( isFuture ) {
				classNames.push('future');
			}
			let rating = '';

			if( event.isNewGame ) {
				rating = {
					tag: 'div',
					className: 'rating rating-new',
					els: [
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: D.Lang.get('events.new_event')
								}
							]
						},
						event.settings.gameType === 'race' && event.stats.players >= 10 ? {
							tag: 'span',
							els: [
								' · ',
								D.Lang.nget(event.stats.players, 'event.users_played')
							]
						} : ''
					]
				};
			} else {
				rating = {
					tag: 'div',
					className: 'rating',
					els: [
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: event.userRating.rating ? event.userRating.rating.toFixed(2) : '-'
								},
								event.userRating.users ? ' (' + event.userRating.users + ')' : ''
							]
						},
						' · ',
						D.Lang.nget(event.stats.players, 'event.users_played')
					]
				};
			}

			let footer = '';
			if( isFuture ) {
				footer = {
					tag: 'div',
					className: 'image-footer',
					els: [
						{
							tag: 'div',
							className: 'date',
							text: this._getEventDate(event)
						}
					]
				};
			} else {
				let hours = Math.ceil((event.endTime - event.startTime) / 3600);
				if( event.settings.gameType === 'anytime' ) {
					hours = Math.ceil(event.settings.gameTime / 60);
				}
				footer = {
					tag: 'div',
					className: 'image-footer',
					els: [
						{
							tag: 'div',
							className: 'black',
							els: [
								{
									tag: 'div',
									className: 'black',
									els: [
										{
											tag: 'span',
											title: D.Lang.get('events.item.time'),
											className: 'icon-box',
											els: [
												D.svgIcon('time'),
												{tag: 'span', text: hours + 'h'}
											]
										},
										event.stats.distance > 0 ? {
											tag: 'span',
											className: 'icon-box',
											title: D.Lang.get('events.item.distance'),
											els: [
												D.svgIcon('distance'),
												{tag: 'span', text: Math.round(event.stats.distance / 1000) + 'km'}
											]
										} : ''
									]
								}
							]
						}
					]
				};
			}

			this.node = mkE({
				tag: 'div',
				className: classNames.join(' '),
				els: [
					{
						tag: this.isStatic ? 'span' : 'a',
						href: this.isStatic ? null : D.url('/event/' + event.seoTitle),
						className: 'cover',
						style: {
							backgroundImage: webImage || !event.hasImage ? '' : 'url(' + event.image.medium + ')'
						},
						els: [
							{
								tag: 'div',
								className: 'image-top',
								els: [
									event.settings.transportType !== 'virtual' ? {
										tag: 'div',
										className: 'icon-box',
										title: D.Lang.get('events.filter.transportType.' + event.settings.transportType),
										els: [
											D.svgIcon('transport-type-' + event.settings.transportType)
										]
									} : '',
									event.stats.pins ? {
										tag: 'div',
										className: 'icon-box pins',
										title: D.Lang.get('events.item.pins'),
										els: [
											D.svgIcon('pins'),
											{tag: 'span', text: event.stats.pins}
										]
									} : ''
								]
							},
							footer
						]
					},
					{
						tag: 'div',
						className: 'header',
						els: [
							{
								tag: this.isStatic ? 'span' : 'a',
								href: this.isStatic ? null : D.url('/event/' + event.seoTitle),
								className: 'title',
								text: event.title
							},
							rating
						]
					}
				]
			});
		},
		_getEventDate() {
			const event = this.event;
			if( event.settings.hasUnknownDate ) {
				return D.Lang.get('event.welcome.soon');
			}
			if( event.settings.gameType === 'race' ) {
				let startDate = new D.Date(event.startTime);
				let endDate = new D.Date(event.endTime);
				let endFormat = '%H:%i';
				if( startDate.getMonth() !== endDate.getMonth() || startDate.getDate() !== endDate.getDate() ) {
					endFormat = D.Lang.get('events.list.dateFormat') + ', %H:%i';
				}
				return startDate.format2(D.Lang.get('events.list.dateFormat') + ', %H:%i').toUpperCase() + '-' + endDate.format2(endFormat).toUpperCase();
			}
			return '';
		}
	},
	mkE.Base
);
